<form-layout
    [showSave]="canSave"
    (onSave)="onSaveClick()"
    (onBack)="onBackClick()"
    (onNext)="onSaveAndNextClick()">

    <finance-data [form]="financeDataProcessStepForm" [showimport]="showimport" [finanzplanDocumentId]="finanzplanDocumentId" (documentUploaded)="onDocumentUploaded($event)"></finance-data>
</form-layout>